"use client"

import dynamic from "next/dynamic"

const ScrollToTop = dynamic(
  () => import("@/components/ui/ScrollToTop").then((mod) => mod.ScrollToTop),
  { ssr: false },
)

export function ScrollToTopWrapper() {
  return <ScrollToTop />
}
